<template>
  <div class="flex flex-grow pb-12">

    <div class="w-full">
      <div class="flex justify-center mt-5 mx-5">
        <section-picker ref="picker"
                        title-open="Choose case"
                        title-closed="Add case"
                        :picker-items="pickerItems"
                        class="w-full"/>

        <delete-condition-button :bot-id="botId" />
      </div>

      <div class="mt-10 px-12 text-gray text-sm flex justify-center items-center">
        <span>Conditions are evaluated from top to bottom</span>
        <vs-icon class="text-gray text-lg" icon="arrow_downward"/>
      </div>

      <condition-cases-section :condition-state-id="conditionStateId" :bot-id="botId" class="px-12" />

    </div>
  </div>
</template>

<script>
import SectionPicker from '../message/SectionPicker'
import DeleteConditionButton from './DeleteConditionButton'
import ConditionCasesSection from './ConditionCasesSection'
import answerController from '@/controllers/answer.controller'
import templateController from '@/controllers/template.controller'
import templateModule from '@/store/modules/template.module'
import { CONDITION_CASES } from '@/store/constants'
import conditionUtils from '../../../utils/condition.utils'
import { CUSTOMERS_URL_LABEL } from '@/utils/key-regex.constants'
import chatBubbleModule from '@/store/modules/chat-bubble.module'
import botModule from '@/store/modules/bot.module'

export default {
  name: 'ConditionEditor',

  components: {
    DeleteConditionButton,
    ConditionCasesSection,
    SectionPicker
  },

  props: {
    botId: {
      type: String,
      required: true
    },
    conditionStateId: {
      type: String,
      required: true
    }
  },
  
  computed: {
    template: templateModule.template,
    collapseKey: chatBubbleModule.collapseKey,

    previewController() {
      return templateModule.isTemplateEditor() ? templateController : answerController
    },

    isEmailBot() {
      return botModule.isEmailBot()
    },

    pickerItems() {
      const items = [
        {
          title: 'Operator Status',
          icon: 'operator',
          onClick: () => this.addConditionCase(CONDITION_CASES.OPERATOR_AVAILABLE),
          disabled: () => false,
          disabledHint: () => null,
          order: 0
        },
        {
          title: 'Day',
          icon: 'day',
          onClick: () => this.addConditionCase(CONDITION_CASES.DAY),
          disabled: () => false,
          disabledHint: () => null,
          order: 1
        },
        {
          title: 'Time Between',
          icon: 'time-between',
          onClick: () => this.addConditionCase(CONDITION_CASES.TIME_BETWEEN),
          disabled: () => false,
          disabledHint: () => null,
          order: 2
        },
        {
          title: 'Channel',
          icon: 'channel',
          onClick: () => this.addConditionCase(CONDITION_CASES.CHANNEL_TYPE),
          disabled: () => false,
          disabledHint: () => null,
          order: 3
        },
        {
          title: CUSTOMERS_URL_LABEL,
          icon: 'url',
          onClick: () => this.addConditionCaseBrowserUrl(CONDITION_CASES.BROWSER_URL),
          disabled: () => false,
          disabledHint: () => null,
          order: 4
        },
        {
          title: 'Context',
          icon: 'context',
          onClick: () => this.addConditionCase(CONDITION_CASES.CONTEXT),
          disabled: () => false,
          disabledHint: () => null,
          order: 5
        }
      ]
      if (this.isEmailBot) {
        items.push({
          title: 'Chat GPT Call Operator',
          icon: 'operator',
          onClick: () => this.addConditionCase(CONDITION_CASES.CONTEXT_CHATGPT_CALL_OPERATOR),
          disabled: () => false,
          disabledHint: () => null,
          order: 6
        })
      }
      return items
    }
  },

  methods: {
    addConditionCase(conditionCase) {
      const templateId = this.template?.id
      this.previewController.addCaseToCondition(this.conditionStateId, conditionUtils.createConditionJson(conditionCase), templateId)
      this.$refs.picker.close()
      this.collapseKey = Math.random()
    },

    addConditionCaseBrowserUrl(conditionCase) {
      this.addConditionCase(conditionCase)
      this.collapseKey = Math.random()
    }
  }
}
</script>
